import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import HomePage from './pages/HomePage';
import PropertiesPage from './pages/PropertiesPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import BookingPage from './pages/BookingPage';
import LocationPage from './pages/LocationPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AuthCallback from './pages/AuthCallback';
import Header from './components/Header';
import Footer from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';

const AppRouter = () => {
  const location = useLocation();

  // Check URL fragment (not query params) for session_id - handled synchronously to prevent race condition
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdminRoute && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/appartamenti" element={<PropertiesPage />} />
        <Route path="/appartamenti/:id" element={<PropertyDetailPage />} />
        <Route path="/prenota" element={<BookingPage />} />
        <Route path="/location" element={<LocationPage />} />
        <Route path="/galleria" element={<GalleryPage />} />
        <Route path="/contatti" element={<ContactPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/cancel" element={<PaymentCancelPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
      </Routes>
      {!isAdminRoute && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
      </LanguageProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
